import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-smarthome',
  templateUrl: './smarthome.component.html',
  styleUrls: ['./smarthome.component.css']

})
export class SmartHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}